export const requestMethods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};



// WEBPACK FOOTER //
// ./src/Constants/requestMethods.js